module.exports = __webpack_public_path__ + "img/FOCI.2baf449c.jpeg";